// extracted by mini-css-extract-plugin
export default {"wrap":"Eq-z","fullWidth":"Fq-z","items":"Gq-z","featureCss":"Hq-z","disabled":"Iq-z","imgCss":"Jq-z"};